module.exports = __webpack_public_path__ + "static/img/nav-footer.0462ad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/nav-footer.png
// module id = O+It
// module chunks = 1